import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKitesurfNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M27.953 21.28L24.985 9.298c.129-2.587-.605-5.065-2.411-6.872C20.418.271 17.315-.354 14.199.183c-3.12.538-6.372 2.248-9.07 4.946C2.431 7.828.721 11.08.183 14.2c-.538 3.116.087 6.22 2.243 8.375 1.806 1.807 4.284 2.54 6.872 2.412l11.98 2.968-2.162 2.162 1.768 1.768 11-11-1.768-1.768zM6.897 6.897a16.326 16.326 0 014.198-3.06l1.958 5.385a14.997 14.997 0 00-2.088 1.743c-.658.658-1.241 1.36-1.744 2.089l-5.385-1.959a16.327 16.327 0 013.06-4.198zm8.365 1.083l-1.839-5.058c.404-.115.805-.207 1.2-.275 2.558-.441 4.756.12 6.183 1.547.858.858 1.402 1.991 1.605 3.315-1.36-.536-2.902-.63-4.43-.366-.903.156-1.818.437-2.719.837zm3.144 1.626c1.82-.313 3.34.076 4.331 1.014l3.152 12.724-.389.389-7.087-7.087-2.294-6.31a9.185 9.185 0 012.287-.73zm4.937 16.284L10.62 22.738c-.939-.992-1.328-2.512-1.014-4.331a9.185 9.185 0 01.73-2.288l6.31 2.295 7.086 7.086zm-10.61-13.157c.39-.39.795-.746 1.21-1.066l1.3 3.576-3.576-1.3c.32-.415.675-.82 1.066-1.21zm-9.811.69l5.057 1.84c-.399.9-.68 1.815-.836 2.719-.264 1.528-.17 3.069.365 4.43-1.323-.204-2.456-.748-3.314-1.606-1.427-1.427-1.989-3.624-1.548-6.182.069-.395.16-.796.276-1.2z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKitesurfNormalMedium;
